import React from "react";
import mapData from "./ConditionChartDataMapper";
import PieChart from "./PieChartContainer";

export default ({t, data: {conditionStatData}, theme: {palette}}) => (
    <PieChart mappedData={mapData(conditionStatData, t, palette.secondary.main)}/>
);